module.exports = function processVersion() {
  return process.version;
};
